import { MdLogout } from "react-icons/md";
import styles from "./nav.module.scss";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "@/store/reducers/auth";

const _links: { path: string, label: string }[] = [
    { path: '/bestekken', label: 'Bestekken' },
    { path: '/hoofdcodes', label: 'Hoofdcodes' },
    { path: '/bepalingen', label: 'Bepalingen' }, // NEW: Add bepalingen
    { path: '/ovks', label: 'Overeenkomsthouders' },
    // { path: '/word-count', label: 'Hoofdc. 99 tekstgebruik' }
]

export default function Nav() {
    const dispatch = useDispatch();

    const docsUrl: string = process.env.REACT_APP_DOCS_URL!;

    const imagePath: string = `${process.env.PUBLIC_URL}/images/CROW-logo.svg`.replace("//", "/");

    return (
        <div className={styles.nav}>
            <NavLink className={styles.nav_item} to="/">
                <img src={imagePath} alt="Logo" />
            </NavLink>

            {
                _links.map((l) => {
                    return <NavLink key={l.path} className={({ isActive, isPending }) => `${styles.nav_item} ${isActive ? styles.active : '' }`} to={l.path}>{l.label}</NavLink>
                })
            }

            <div className={styles.spacer}></div>

            <a className={styles.docs_link + " " + styles.nav_item} href={docsUrl} target="_blank">Docs</a>
            <div className={styles.nav_item} onClick={(e) => dispatch(authActions.signout())}>
                <MdLogout size={24} />
            </div>
        </div>
    )
}